import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { userApi } from '@/api'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { mergeCurrentUserSettings } from '@/store/slices/userSlice'
import {
  HELP_LANG_STORAGE_KEY, LOCALE_STORAGE_KEY, type AppLocale,
} from './locales'

export function useLocale() {
  const { i18n, t } = useTranslation('common')
  const dispatch = useAppDispatch()
  const userId = useAppSelector((s) => s.user.userId)
  const settings = useAppSelector((s) => s.user.settings)

  const setLocale = useCallback(async (lng: AppLocale) => {
    if (lng === i18n.language) return
    await i18n.changeLanguage(lng)
    localStorage.setItem(LOCALE_STORAGE_KEY, lng)
    localStorage.setItem(HELP_LANG_STORAGE_KEY, lng) // help 中心联动
    if (userId) {
      const merged = { ...(settings ?? {}), preferredLocale: lng }
      userApi.updateUser(String(userId), { settings: merged })
        .then(() => dispatch(mergeCurrentUserSettings({ preferredLocale: lng })))
        .catch((e) => {
          // 不回滚本地切换；dump 便于查后端
          console.warn('[i18n] persist preferredLocale failed', { userId, lng, error: e })
          toast.error(t('toast.localePersistFailed'))
        })
    }
  }, [i18n, userId, settings, dispatch, t])

  return { locale: i18n.language, setLocale }
}
